import * as React from 'react';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import HelpOutlinedIcon from '@mui/icons-material/HelpOutlined';
import styles from './styles/Layout.module.css';

export default function Layout({ children, activeTab, onTabChange }) {
  React.useEffect(() => {
    // 处理移动端100vh问题
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    setVH();
    window.addEventListener('resize', setVH);
    return () => window.removeEventListener('resize', setVH);
  }, []);

  return (
    <div className={styles.rootContainer}>
      <CssBaseline />
      <main className={styles.contentArea}>{children}</main>
      <Paper elevation={0} className={styles.navigationPaper}>
        <BottomNavigation
          showLabels
          value={activeTab}
          onChange={(event, newValue) => {
            onTabChange(newValue);
          }}
          className={styles.bottomNavigation}
        >
          <BottomNavigationAction label="AI Assistant" />
          <BottomNavigationAction label="Checklist" />
          <BottomNavigationAction
            showLabels={false}
            icon={
              activeTab === 2 ? (
                <HelpOutlinedIcon />
              ) : (
                <HelpOutlineOutlinedIcon />
              )
            }
          />
        </BottomNavigation>
      </Paper>
    </div>
  );
}
